// extracted by mini-css-extract-plugin
module.exports = {"tabProfile":"Profile_tabProfile__3b13Z","navbarContent":"Profile_navbarContent__2oLCw","navActive":"Profile_navActive__2EvcU"};